import styled from '@emotion/styled'
import { MediaQueries } from '@hhgtech/hhg-components/misc'

export const StyledButton = styled.div`
  ${MediaQueries.mbUp} {
    position: fixed;
    right: 87px;
    bottom: 50px;
    img {
      width: 37px;
      height: 37px;
    }
  }

  ${MediaQueries.mbDown} {
    display: none;
  }
`
